var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"dense":""}},[_c('b',[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_c('span',[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }